import React, { Component } from 'react';
import propTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import cn from 'classnames';

import { DAY_WEEK_EVENT } from '~/Config/DragTypes';
import { onlyTime } from '~/Components/Global/CalendarEvents/FormatDateTime';
import { eventFontSizeHelper } from '~/Components/Global/FontWrapper/FontWrapper';

const eventDrag = {
  canDrag: ({ isDeleting }) => {
    return !isDeleting;
  },
  beginDrag: ({ event }) => {
    return {
      event: { ...event },
    };
  },
  endDrag: ({ clearEvent }) => {
    clearEvent();
  },
};

const dragCollect = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

@DragSource(DAY_WEEK_EVENT, eventDrag, dragCollect)
export default class DynamicEvent extends Component {
  constructor() {
    super();
    this.state = {
      zIndex: 'initial',
    };
  }

  handleOnEventClick = (e, event) => {
    e.stopPropagation();
    this.props.setCurrentEvent(event, true);
  };

  componentWillReceiveProps = next => {
    if (next.isDragging && this.state.zIndex !== -1) {
      setTimeout(() => {
        this.setState({ zIndex: -1 });
      }, 100);
    }
    if (!next.isDragging && this.state.zIndex !== 'initial') {
      this.setState({ zIndex: 'initial' });
    }
  };

  render() {
    const {
      event,
      connectDragSource,
      isDragging,
      fontNameForEvents,
      day,
      top,
      height,
    } = this.props;
    if (event.isAllDay) return null;

    const continuedFromPrevious = event.startInZone.isBefore(day.clone().startOf('day'));

    const style = {
      top: `${top / 10}rem`,
      // top,
      height: `calc(${height / 10}rem - 0.2rem)`,
      width: `calc(100% - 0.2rem)`,
      zIndex: this.state.zIndex,
      background: event.color || event.calendar?.color,
      wordBreak: event.endInZone.diff(event.startInZone, 'minutes') < 60 ? 'break-all' : 'inherit',
      fontFamily: fontNameForEvents,
    };

    const fontClass = `font-${fontNameForEvents.replace(/\s/g, '-')}`;

    return connectDragSource(
      <div
        onClick={e => this.handleOnEventClick(e, event)}
        style={style}
        className={cn('event-wrapper', fontClass, { dragging: isDragging })}
      >
        <div className="event-text-wrapper">
          {!continuedFromPrevious && (
            <span
              style={{
                float: event.endInZone.diff(event.startInZone, 'minutes') <= 30 ? 'none' : 'left',
                fontSize: eventFontSizeHelper(fontNameForEvents),
              }}
            >
              {onlyTime(event.startInZone.clone())}
            </span>
          )}
          <span className="event-text" style={{ fontSize: eventFontSizeHelper(fontNameForEvents) }}>
            {event.summary}
          </span>
        </div>
      </div>
    );
  }
}

DynamicEvent.propTypes = {
  event: propTypes.object,
  connectDragSource: propTypes.func,
  setCurrentEvent: propTypes.func,
  isDragging: propTypes.bool,
  fontNameForEvents: propTypes.string,
  day: propTypes.object,
  height: propTypes.number.isRequired,
  top: propTypes.number.isRequired,
};
